<template v-slot="main">
  <div class="modal-container">
    <div class="modal-header">
      <h2>{{ $t('location_modal.title') }}</h2>
    </div>

    <div class="modal-body">
      <p><gmap-autocomplete id="google-maps-input"
          class="gmap-search"
          :placeholder="$t('location_modal.search')"
          selectFirstOnEnter
          v-on:place_changed="addLocation">
        </gmap-autocomplete>
        <search-icon />
      </p>
      <div class="places" v-for="(place, index) in places"
           v-bind:key="index + 'address'">
        <div class="place">
          <GmapMap
            :center="{
              lat: place.location.position.lat,
              lng: place.location.position.lng}"
            :zoom="12"
            style="width:150px;  height: 150px;">
            <GmapMarker
              :key="index"
              :position="google && new google.maps.LatLng(place.location.position.lat, place.location.position.lng)"
            />
          </GmapMap>
          <div>
            <p class="address-name">{{place.location.label}}</p>
            <button class="btn btn-danger" v-on:click="removeLocation(index)">
              <span>
                <x-circle-icon />
                {{ $t('Remove') }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button v-on:click="closeModal" class="btn btn-inline btn-inverse">
        {{ $t('Cancel') }}
      </button>
      <button v-on:click="sendLocations" class="btn btn-inline">
        {{ $t('OK') }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// eslint-disable-next-line
import * as VueGoogleMaps from 'vue2-google-maps'
import { SearchIcon, XCircleIcon } from 'vue-feather-icons'
// eslint-disable-next-line
import { gmapApi } from 'vue2-google-maps'

import BaseModal from '@/layout/modals/BaseModal.vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBJOuzulOvveitkxW97BoPcW_3qToOXoZo',
    libraries: 'places' // necessary for places input
  }
})

export default {
  extends: BaseModal,
  name: 'SendLocationsModal',
  components: { SearchIcon, XCircleIcon },
  data () {
    return {
      places: []
    }
  },
  computed: {
    google: gmapApi
  },
  methods: {
    addLocation (place) {
      const el = document.getElementById('google-maps-input')
      let placeHelper = {}
      if (place.geometry == null) {
        return
      }
      placeHelper.kind = 'location'
      placeHelper.location = {}
      placeHelper.location.position = place.geometry.location
      placeHelper.location.label = place.formatted_address

      placeHelper = JSON.stringify(placeHelper)
      this.places.push(JSON.parse(placeHelper))
      el.value = ''
    },
    removeLocation (placeIndex) {
      this.places.splice(placeIndex, 1)
    },
    sendLocations () {
      this.$store.dispatch('rooms/sendLocations', this.places)
      this.closeModal()
    }
  }
}

</script>

<style lang="scss" >
.modal-body {
  input.gmap-search#google-maps-input {
    padding-right: 35px;
    width: 100%;
  }

  .vue-map-container {
    background-color: #666ee8;
    border-color: #666ee8;
    border: 4px solid #666ee8;
    border-radius: 3px;
    color: #996;

    + div p {
      padding: 0 1.5rem;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }

  svg {
    margin-left: -35px;
    margin-top: 10px;
    position: absolute;
  }

  .places {
    display: flex;
    flex-direction: column;

    .place {
      display: flex;
      flex-direction: row;
      margin: 1rem 0;
    }
  }
}

.pac-container {
  z-index: 100000;
}

</style>
